import { useAppConfigStore } from '@/stores/appConfig'

const APP_BIND_SCHEME = 'luckywallet://merchant/bind'
const APP_INVITE_SCHEME = 'luckywallet://merchant/invite'

export function buildAppBindSchemeUrl(token?: string) {
  const params = new URLSearchParams({ action: 'third-bind' })
  if (token) {
    params.set('token', token)
  }
  return `${APP_BIND_SCHEME}?${params.toString()}`
}

/** 构建邀请码唤起链接，例如 luckywallet://merchant/invite?code=TF3YQ2 */
export function buildAppInviteSchemeUrl(code: string) {
  const params = new URLSearchParams({ code: code.trim() })
  return `${APP_INVITE_SCHEME}?${params.toString()}`
}

function getDownloadPage() {
  return useAppConfigStore().config?.endpoints.landing || import.meta.env.VITE_APP_DOWNLOAD_PAGE
}

/**
 * 尝试用自定义 Scheme 唤起 APP；若短时间内页面仍可见，则判定失败并跳转下载页
 */
function openSchemeOrDownloadPage(schemeUrl: string) {
  const downloadPage = getDownloadPage()

  if (!downloadPage) {
    window.location.href = schemeUrl
    return
  }

  const start = Date.now()
  let fallenBack = false

  const cleanup = () => {
    document.removeEventListener('visibilitychange', onVisibilityChange)
    window.clearTimeout(timer)
  }

  const fallback = () => {
    if (fallenBack) return
    fallenBack = true
    cleanup()
    window.location.href = downloadPage
  }

  const onVisibilityChange = () => {
    if (document.hidden) {
      cleanup()
    }
  }

  document.addEventListener('visibilitychange', onVisibilityChange)

  const timer = window.setTimeout(() => {
    if (!document.hidden && Date.now() - start < 3000) {
      fallback()
    } else {
      cleanup()
    }
  }, 2500)

  window.location.href = schemeUrl
}

/** 尝试唤起 APP（三方绑定），失败则跳转下载页 */
export function openAppOrDownloadPage(token?: string) {
  openSchemeOrDownloadPage(buildAppBindSchemeUrl(token))
}

/** 尝试唤起 APP 并注入邀请码，失败则跳转下载页 */
export function openAppInviteOrDownloadPage(code: string) {
  const trimmed = code.trim()
  if (!trimmed) return
  openSchemeOrDownloadPage(buildAppInviteSchemeUrl(trimmed))
}
